<template>
  <div v-loading="loading">
    <div class="title">个人资料</div>
    <el-divider></el-divider>
    <el-form
      ref="profileInfo"
      :model="profileInfo"
      :rules="profileInfoRules"
      label-width="130px"
      inline-message
    >
      <el-form-item label="手机：">
        {{ userPhone }}
      </el-form-item>
      <el-form-item label="头像：" v-if="false">
        <UploadImage
          space="_for_expert_sub_project"
          folder="fuwu"
          :api="api"
          uploadWidth="upload-w-134"
          :uploadLimit="300"
          :cover_url.sync="profileInfo.avatar_file.path"
          :cover_file_id.sync="profileInfo.avatar_file.id"
        />
      </el-form-item>
      <el-form-item label="昵称：" prop="nickname">
        <el-input
          class="w-300"
          v-model="profileInfo.nickname"
          placeholder="请输入昵称"
        />
      </el-form-item>
      <el-form-item label="性别：" prop="gender">
        <el-select
          class="w-300"
          v-model="profileInfo.gender"
          placeholder="请选择性别"
        >
          <el-option
            v-for="item in gender"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="生日：" prop="birthday">
        <el-date-picker
          class="w-300"
          v-model="profileInfo.birthday"
          type="date"
          placeholder="请选择出生日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="微信号：" prop="wechat">
        <el-input
          class="w-300"
          v-model="profileInfo.wechat"
          placeholder="请输入微信号"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <el-input
          class="w-300"
          v-model="profileInfo.email"
          placeholder="请输入邮箱"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="个人简介：" prop="introduction">
        <el-input
          class="w-300"
          v-model="profileInfo.introduction"
          style="width:340px;height: 120px;"
          type="textarea"
          :maxlength="200"
          :rows="5"
          placeholder="一句话啊介绍一下自己吧，让别人更了解你"
        />
      </el-form-item>
      <el-form-item label="个人形象照：">
        <UploadImage
          space="_for_expert_sub_project"
          folder="fuwu"
          :api="api"
          uploadWidth="upload-w-1920"
          :uploadLimit="1000"
          :cover_url.sync="profileInfo.self_avatar.path"
          :cover_file_id.sync="profileInfo.self_avatar.id"
        />
        <el-alert
          class="w-300 mt-12 alert-content"
          title="请上传不大于10M的单人照片"
          type="warning"
          show-icon
        >
        </el-alert>
      </el-form-item>
      <el-form-item>
        <el-button :loading="btnLoading" type="primary" @click="handleSubmit">
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import UploadImage from "@/components/UploadImage";
import API from "@/global/request/api";
import settingService from "@/global/service/setting";
import { mapState } from "vuex";

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      loading: true,
      btnLoading: false,
      api: API.settingFile,
      profileInfo: {
        avatar_file: {
          id: null,
          path: ""
        },
        nickname: "",
        gender: "",
        birthday: "",
        wechat: "",
        email: "",
        introduction: "",
        self_avatar: {
          id: null,
          path: ""
        }
      },
      gender: [
        {
          id: 1,
          name: "男"
        },
        {
          id: 2,
          name: "女"
        }
      ],
      avatar: {},
      profileInfoRules: {
        nickname: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" }
        ],
        wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        introduction: [
          { required: true, message: "请输入简介", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(["userPhone"])
  },
  methods: {
    getData() {
      settingService
        .profiles()
        .then(res => {
          res.self_avatar = res.self_avatar
            ? res.self_avatar
            : {
                id: null,
                path: ""
              };
          this.profileInfo = res;
        })
        .finally(() => (this.loading = false));
    },
    handleSubmit() {
      const params = {
        nickname: this.profileInfo.nickname,
        gender: this.profileInfo.gender,
        birthday: this.profileInfo.birthday,
        wechat: this.profileInfo.wechat,
        email: this.profileInfo.email,
        introduction: this.profileInfo.introduction,
        self_avatar_id: this.profileInfo.self_avatar.id
      };
      this.$refs["profileInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        this.btnLoading = true;
        settingService
          .editProfiles(params)
          .then(() => {
            this.$message.success("保存成功");
            this.$store.dispatch("settingSatage");
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  padding-right: 30px;
}
.alert-content {
  height: 30px;
}
</style>
